import React from 'react';

const LinkWithText = ({
	as: T = 'a',
	urlAttribute = 'href',
	link,
	textFallback = 'Zur Website',
	...attributes
}) => {
	const linkParts = link.split('|');
	const url = linkParts[0];
	const text = linkParts.length === 2 ? linkParts[1] : textFallback;

	return (
		<T {...{[urlAttribute]: url}} {...attributes}>
			{text}
		</T>
	);
};

export default LinkWithText;
